<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div class="rounded-2xl bg-white p-5 shadow-sm">
          <b-skeleton animation="wave" width="60%" height="24px" class="mb-2"></b-skeleton>
          <b-skeleton animation="wave" width="40%" height="16px" class="mb-4"></b-skeleton>
          <div class="space-y-3">
            <div v-for="i in 5" :key="i" class="flex items-center gap-3">
              <b-skeleton animation="wave" width="28px" height="28px"></b-skeleton>
              <b-skeleton animation="wave" width="60%" height="16px"></b-skeleton>
              <b-skeleton animation="wave" width="30%" height="12px"></b-skeleton>
            </div>
          </div>
        </div>
        <div class="rounded-2xl bg-white p-5 shadow-sm">
          <b-skeleton animation="wave" width="60%" height="24px" class="mb-2"></b-skeleton>
          <b-skeleton animation="wave" width="40%" height="16px" class="mb-4"></b-skeleton>
          <div class="space-y-3">
            <div v-for="i in 5" :key="i" class="flex items-center gap-3">
              <b-skeleton animation="wave" width="28px" height="28px"></b-skeleton>
              <b-skeleton animation="wave" width="60%" height="16px"></b-skeleton>
              <b-skeleton animation="wave" width="30%" height="12px"></b-skeleton>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div class="rounded-2xl bg-white p-5 shadow-sm">
        <div class="flex items-start gap-2 mb-1">
          <span class="text-lg">🏆</span>
          <h3 class="text-lg font-bold text-gray-800">Top 5 Mejores Categorías</h3>
        </div>
        <p class="text-sm text-gray-500 mb-4">Basado en precisión histórica.</p>

        <div v-if="topCategories.length" class="space-y-3">
          <div
            v-for="(category, index) in topCategories"
            :key="index"
            class="flex items-center gap-3 rounded-xl bg-gray-50/60 px-3 py-2 transition-all duration-200 hover:bg-gray-100"
          >
            <span class="flex h-7 w-7 items-center justify-center rounded-full bg-emerald-50 text-emerald-600 text-xs font-semibold">
              {{ index + 1 }}
            </span>
            <span class="flex-1 text-sm font-medium text-gray-700 truncate">{{ category.name }}</span>
            <div class="flex items-center gap-2 w-32">
              <div class="relative w-full h-2 bg-emerald-100 rounded-full overflow-hidden">
                <div
                  class="absolute left-0 top-0 h-full bg-emerald-500 rounded-full"
                  :style="{ width: category.precision + '%' }"
                ></div>
              </div>
              <span class="text-xs font-semibold text-emerald-700 tabular-nums">{{ category.precision }}%</span>
            </div>
          </div>
        </div>
        <p v-else class="text-sm text-gray-400">Aún no hay datos para mostrar.</p>
      </div>

      <div class="rounded-2xl bg-white p-5 shadow-sm">
        <div class="flex items-start gap-2 mb-1">
          <span class="text-lg">💪</span>
          <h3 class="text-lg font-bold text-gray-800">Top 5 Áreas a Reforzar</h3>
        </div>
        <p class="text-sm text-gray-500 mb-4">Oportunidades de mejora prioritarias.</p>

        <div v-if="worstCategories.length" class="space-y-3">
          <div
            v-for="(category, index) in worstCategories"
            :key="index"
            class="flex items-center gap-3 rounded-xl bg-gray-50/60 px-3 py-2 transition-all duration-200 hover:bg-gray-100"
          >
            <span class="flex h-7 w-7 items-center justify-center rounded-full bg-amber-50 text-amber-600 text-xs font-semibold">
              {{ index + 1 }}
            </span>
            <span class="flex-1 text-sm font-medium text-gray-700 truncate">{{ category.name }}</span>
            <div class="flex items-center gap-2 w-32">
              <div class="relative w-full h-2 bg-amber-100 rounded-full overflow-hidden">
                <div
                  class="absolute left-0 top-0 h-full bg-amber-500 rounded-full"
                  :style="{ width: category.precision + '%' }"
                ></div>
              </div>
              <span class="text-xs font-semibold text-amber-700 tabular-nums">{{ category.precision }}%</span>
            </div>
          </div>
        </div>
        <p v-else class="text-sm text-gray-400">Aún no hay datos para mostrar.</p>
      </div>
    </div>
  </b-skeleton-wrapper>
</template>

<script>
import { getWorstAndBestSubCategories } from "@/services/stats.service";

export default {
  name: 'BestAndWorstSubcategories',
  data() {
    return {
      loading: true,
      topCategories: [
        // { name: 'Ecuaciones e Inecuaciones', precision: 91 },
        // { name: 'Geometría algebraica', precision: 81 },
        // { name: 'Solidos geométricos', precision: 81 },
        // { name: 'Expresiones algebraicas', precision: 81 },
      ],
      worstCategories: [
        // { name: 'Ecuaciones enecotenes', precision: 60 },
        // { name: 'Geometría algebraica', precision: 55 },
        // { name: 'Sólidos geométricos', precision: 55 },
        // { name: 'Operaciones básicas', precision: 41 },
      ]
    };
  },

  props: {
    isPremium: {
      type: Boolean,
      default: true
    },
    forStudentId: {
      type: [Number, String],
      default: null
    }
  },

  watch: {
    isPremium(newValue) {
      if (newValue) {
        this.loading = true;
        this.loadCategories();
      } else if (newValue === false) {
        this.loading = false;
        this.topCategories = [];
        this.worstCategories = [];
      }
    },
    forStudentId() {
      if (this.isPremium) {
        this.loading = true;
        this.loadCategories();
      }
    }
  },

  async created() {
    // Si no es premium, mantener loading indefinidamente y no cargar datos
    if (this.isPremium === false) {
      this.loading = false;
      return;
    }

    if (this.isPremium) {
      await this.loadCategories();
    }
  },

  mounted() {
    // Si no es premium, mantener skeleton indefinidamente
    if (this.isPremium === false) {
      this.loading = false;
    }
  },

  methods: {
    async loadCategories() {
      if (!this.isPremium) {
        return;
      }

      try {
        const response = await getWorstAndBestSubCategories(this.forStudentId);
        if (!response) {
          this.topCategories = [];
          this.worstCategories = [];
          this.loading = false;
          return;
        }
        this.topCategories = response.best?.map(cat => ({
          name: cat.key,
          precision: (cat.accuracy * 100).toFixed(2)
        })) || [];
        this.worstCategories = response.worst?.map(cat => ({
          name: cat.key,
          precision: (cat.accuracy * 100).toFixed(2)
        })) || [];
        this.loading = false; // Ocultar skeleton inmediatamente después de cargar
      } catch (error) {
        console.error("Error fetching best and worst subcategories:", error);
        this.loading = false; // Ocultar skeleton incluso si hay error
      }
    }
  }
};
</script>